var render = function render(){var _vm=this,_c=_vm._self._c;return _c('flex-grid',{staticClass:"settings-header",attrs:{"align-items":"center"}},[_c('flex-grid-item',{attrs:{"grow":"1"}},[_c('h2',[_vm._v(_vm._s(_vm.displayTitle))])]),_c('flex-grid-item',{attrs:{"width":"40px"}},[_c('button-icon',{attrs:{"icon":"icon_delete-thin","size":"30px"},on:{"click":_vm.onCloseClick}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }